import { GQL } from "@binale-tech/shared";

export type AssistantStep =
    | { kind: "bewirtung"; documentId: string }
    | { kind: "bankPick"; documentId: string; candidateTransactionIds: string[] }
    | { kind: "where"; documentId: string };

const WHERE_REASONS: ReadonlySet<GQL.IDmsAutoSortReason> = new Set([
    GQL.IDmsAutoSortReason.NoBankMatch,
    GQL.IDmsAutoSortReason.PaymentMixed,
    GQL.IDmsAutoSortReason.PaymentUnknown,
]);

const toFolderStep = (result: GQL.IDmsAutoSortResult): AssistantStep[] => {
    if (result.outcome !== GQL.IDmsAutoSortOutcome.Unchanged || !result.reason) {
        return [];
    }
    if (result.reason === GQL.IDmsAutoSortReason.BankAmbiguous) {
        return [
            {
                kind: "bankPick",
                documentId: result.documentId,
                candidateTransactionIds: result.candidateTransactionIds,
            },
        ];
    }
    return WHERE_REASONS.has(result.reason) ? [{ kind: "where", documentId: result.documentId }] : [];
};

export const buildAssistantQueue = (results: GQL.IDmsAutoSortResult[]): AssistantStep[] => [
    ...results
        .filter((result) => result.isBewirtungCandidate)
        .map((result): AssistantStep => ({ kind: "bewirtung", documentId: result.documentId })),
    ...results.flatMap(toFolderStep),
];
